import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import { RootState } from '@/src/reducers/types';
import { cn } from '@/src/util/ui';

type WorkstreamAvatarProps = {
  id?;
  className?: string;
  name: string;
  avatar;
  workstreamColor?;
  disableTooltip?: boolean;
};

const WorkstreamAvatar = ({
  id,
  name,
  disableTooltip,
  avatar,
  workstreamColor,
  className,
}: WorkstreamAvatarProps) => {
  const image = avatar !== 'default.png' ? `/api/file/profile_pictures/${avatar}` : null;

  const avatarContainerClasses = clsx(
    'container--avatar',
    'tw-relative tw-overflow-hidden',
    'tw-flex tw-items-center tw-justify-center',
    'tw-w-[20px] tw-h-[20px] tw-rounded-[25px]',
    'tw-text-[10px] tw-text-cfo-black tw-font-brandonTextMedium',
    'tw-shadow-[0px_1px_2px_0px_rgba(65,74,79,0.10)]',
    'tw-mr-[5px] ',
    'hover:tw-bg-cfo-blue-600 hover:tw-text-white',
    disableTooltip && 'disableTooltip'
  );

  const formatInitials = name.slice(0, 3);

  return (
    <div className={cn('tw-flex tw-items-center tw-justify-center', className)}>
      <div className={clsx('tw-cursor-default')} data-tooltip-id={`avatar_${id}_tooltip`}>
        <div className={avatarContainerClasses} style={{ backgroundColor: workstreamColor }}>
          <span className={clsx('tw-leading-none tw-text-white tw-uppercase')}>
            {formatInitials}
          </span>
          {image && <img src={image} alt="Workstream Avatar" />}
        </div>
      </div>
      {!disableTooltip && (
        <Tooltip
          id={`avatar_${id}_tooltip`}
          className={clsx('tw-ml-[-35px] !tw-mt-[24px]')}
          place="right"
          effect="solid"
        >
          {name}
        </Tooltip>
      )}
    </div>
  );
};

export default WorkstreamAvatar;
